import script from "./TagView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagView.vue?vue&type=script&setup=true&lang=ts"

import "./TagView.vue?vue&type=style&index=0&id=75ba60da&scope=true&lang=css"

const __exports__ = script;

export default __exports__